module.exports = __webpack_public_path__ + "img/World_Map.cde67075.jpg";